<template>
  <div
    :class="[
      $style.previewField,
    ]"
  >
    <div
      :class="$style.name"
      :style="{ width: `${ratio[0] * 100}%` }"
    >
      {{ name }}
    </div>

    <div
      :class="$style.value"
      :style="{ width: `${ratio[1] * 100}%` }"
    >
      {{ value }}
    </div>
  </div>
</template>

<style lang="scss" module>
.previewField {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 1.5em;
  overflow: hidden;

  @include for-tablet-landscape-up {
    flex-direction: row;
  }
}

.name,
.value {
  @media screen and (max-width: 900px) {
    width: 100% !important;
  }
}

.name {
  flex: 3;
  padding-right: 1em;
  font-size: 1.6rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  color: $color-text;
  opacity: 0.5;
}

.value {
  flex: 7;
  font-size: 1.6rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  color: $color-text;
  word-break: break-word;

  .error & {
    color: $red;
  }
}

</style>

<script>

export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Object, Date, Boolean],
      default: null,
    },
    error: {
      type: [Boolean, String],
      default: false,
    },
    ratio: {
      type: Array,
      default: () => [0.4, 0.6],
      validator(value) {
        return value.length === 2 && value.reduce((a, b) => a + b, 0) === 1;
      },
    },
  },

  methods: {
    openFile() {
      window.open(this.value.src);
    },
  },
};

</script>

